import Vue from 'vue';

const state = { unreadMessagesCount: 0 };

const getters = {
  unreadMessagesCount: (chatState: any) => chatState.unreadMessagesCount,
};

const mutations = {
  unreadMessagesCount: (chatState: any, unreadMessagesCount: number) => {
    chatState.unreadMessagesCount = unreadMessagesCount;
  },
  incrementUnreadMessagesCount: (chatState: any) => {
    chatState.unreadMessagesCount++;
  },
  reduceUnreadMessagesCount: (chatState: any, count: number) => {
    chatState.unreadMessagesCount -= count;
  },
};

export default {
  state,
  getters,
  mutations,
};
